// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CircleProgressSection_Ubr_q {
  margin-top: 50px;
  width: 90%;
  flex-wrap: wrap;
  height: fit-content !important;
  min-height: fit-content;
  margin: 50px 0;
}
.CircleProgress_AC_XM {
  display: grid;
  gap: 10px;
  color: var(--_10a37f-background);
  justify-content: center;
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  margin: 20px 0;
  grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 1100px) {
  .CircleProgress_AC_XM {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 360px) {
  .CircleProgress_AC_XM {
    transform: scale(0.6);
    -webkit-transform: scale(0.6);
    -moz-transform: scale(0.6);
    -ms-transform: scale(0.6);
    -o-transform: scale(0.6);
  }
}
.cardPBContainer_K0TCt {
  display: flex;
  align-items: center;
  justify-content: center;
}
.skill_BwqhT {
  width: 160px;
  height: 160px;
  position: relative;
  box-sizing: border-box;
  transform: scale(0.6);
  -webkit-transform: scale(0.6);
  -moz-transform: scale(0.6);
  -ms-transform: scale(0.6);
  -o-transform: scale(0.6);
}

.label_cLa93 {
  text-align: center;
  width: 100%;
  max-width: 130px;
  margin-left: -35px;
}
.outer_Xh7L_ {
  height: 160px;
  width: 160px;
  padding: 20px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-sizing: border-box;
}

.inner_YGUrk {
  height: 120px;
  width: 120px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

#number_dpRQH {
  font-weight: 700;
  font-size: 30px;
  color: black;
}
.CircleProgressSection_Ubr_q{

  circle {
    fill: none;
    stroke: var(--_10a37f-background);
    stroke-width: 10px;
    stroke-dasharray: 472;
    stroke-dashoffset: 165;
  }
}
#ProgressBarCircle_rav_w {
  position: absolute;
  left: 0;
  top: 0;
  transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
}

.pg0_Sf0Rd,
.pg2_zMVxL {
  stroke-dashoffset: 80;
}
.pg1_ljQ1o {
}

.pg3_iloKb {
  stroke-dashoffset: 190;
}

@media (max-width: 620px) {
  .CircleProgress_AC_XM {
    flex-direction: column;
    gap: 40px;
  }

  .cardPBContainer_K0TCt {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .label_cLa93 {
    margin-left: 0;
  }
}


@media (width <= 620px) {
  .skill_BwqhT {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CircleProgressBar/CircleProgressBar.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;;EAEE;IACE,UAAU;IACV,iCAAiC;IACjC,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;AACvB;AACA;AACA;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;AACF;;;AAGA;EACE;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".CircleProgressSection {\n  margin-top: 50px;\n  width: 90%;\n  flex-wrap: wrap;\n  height: fit-content !important;\n  min-height: fit-content;\n  margin: 50px 0;\n}\n.CircleProgress {\n  display: grid;\n  gap: 10px;\n  color: var(--_10a37f-background);\n  justify-content: center;\n  width: 100%;\n  padding: 0 40px;\n  box-sizing: border-box;\n  margin: 20px 0;\n  grid-template-columns: repeat(4, 1fr);\n}\n\n@media (max-width: 1100px) {\n  .CircleProgress {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 360px) {\n  .CircleProgress {\n    transform: scale(0.6);\n    -webkit-transform: scale(0.6);\n    -moz-transform: scale(0.6);\n    -ms-transform: scale(0.6);\n    -o-transform: scale(0.6);\n  }\n}\n.cardPBContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.skill {\n  width: 160px;\n  height: 160px;\n  position: relative;\n  box-sizing: border-box;\n  transform: scale(0.6);\n  -webkit-transform: scale(0.6);\n  -moz-transform: scale(0.6);\n  -ms-transform: scale(0.6);\n  -o-transform: scale(0.6);\n}\n\n.label {\n  text-align: center;\n  width: 100%;\n  max-width: 130px;\n  margin-left: -35px;\n}\n.outer {\n  height: 160px;\n  width: 160px;\n  padding: 20px;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  box-sizing: border-box;\n}\n\n.inner {\n  height: 120px;\n  width: 120px;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#number {\n  font-weight: 700;\n  font-size: 30px;\n  color: black;\n}\n.CircleProgressSection{\n\n  circle {\n    fill: none;\n    stroke: var(--_10a37f-background);\n    stroke-width: 10px;\n    stroke-dasharray: 472;\n    stroke-dashoffset: 165;\n  }\n}\n#ProgressBarCircle {\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform: rotate(270deg);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n}\n\n.pg0,\n.pg2 {\n  stroke-dashoffset: 80;\n}\n.pg1 {\n}\n\n.pg3 {\n  stroke-dashoffset: 190;\n}\n\n@media (max-width: 620px) {\n  .CircleProgress {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .cardPBContainer {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .label {\n    margin-left: 0;\n  }\n}\n\n\n@media (width <= 620px) {\n  .skill {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CircleProgressSection": `CircleProgressSection_Ubr_q`,
	"CircleProgress": `CircleProgress_AC_XM`,
	"cardPBContainer": `cardPBContainer_K0TCt`,
	"skill": `skill_BwqhT`,
	"label": `label_cLa93`,
	"outer": `outer_Xh7L_`,
	"inner": `inner_YGUrk`,
	"number": `number_dpRQH`,
	"ProgressBarCircle": `ProgressBarCircle_rav_w`,
	"pg0": `pg0_Sf0Rd`,
	"pg2": `pg2_zMVxL`,
	"pg1": `pg1_ljQ1o`,
	"pg3": `pg3_iloKb`
};
export default ___CSS_LOADER_EXPORT___;
